import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { TrendingUp, Users, BookOpen, Lightbulb } from 'lucide-react';
import type { ProjectSnapshotCardProps } from '@shared/widget-schemas';
import { capitalizeFirst } from './textFormat';

const variantConfig = {
  confidence: { icon: TrendingUp, color: 'text-primary', bg: 'bg-primary/10' },
  interviews: { icon: Users, color: 'text-primary', bg: 'bg-primary/10' },
  research: { icon: BookOpen, color: 'text-warning', bg: 'bg-warning/10' },
  recommendations: { icon: Lightbulb, color: 'text-success', bg: 'bg-success/10' },
} as const;

export function ProjectSnapshotCardWidget({ variant, title, value, detail }: ProjectSnapshotCardProps) {
  const { icon: Icon, color, bg } = variantConfig[variant];

  return (
    <Card className="w-full">
      <CardContent className="p-4 flex items-start gap-3">
        <div className={cn('p-2 rounded-lg shrink-0', bg)}>
          <Icon className={cn('h-5 w-5', color)} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{title}</p>
          <p className="text-lg font-bold mt-0.5">{value}</p>
          {detail && <p className="text-xs text-muted-foreground mt-0.5">{capitalizeFirst(detail)}</p>}
        </div>
      </CardContent>
    </Card>
  );
}
